import { __extends } from "tslib";
import { DiffuseBasicMethod, _Shader_DiffuseBasicMethod } from './DiffuseBasicMethod';
/**
 * DiffuseGradientMethod is an alternative to DiffuseBasicMethod in which the shading can be modulated with a gradient
 * to introduce color-tinted shading as opposed to the single-channel diffuse strength. This can be used as a crude
 * approximation to subsurface scattering (for instance, the mid-range shading for skin can be tinted red to similate
 * scattered light within the skin attributing to the final colour)
 */
var DiffuseGradientMethod = /** @class */ (function (_super) {
    __extends(DiffuseGradientMethod, _super);
    /**
     * Creates a new DiffuseGradientMethod object.
     * @param gradient A texture that contains the light colour based on the angle. This can be used to change
     * the light colour due to subsurface scattering when the surface faces away from the light.
     */
    function DiffuseGradientMethod(gradient) {
        var _this = _super.call(this) || this;
        _this._gradient = gradient;
        _this.iAddTexture(_this._gradient);
        return _this;
    }
    Object.defineProperty(DiffuseGradientMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return DiffuseGradientMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiffuseGradientMethod.prototype, "gradient", {
        /**
         * A texture that contains the light colour based on the angle. This can be used to change the light colour
         * due to subsurface scattering when the surface faces away from the light.
         */
        get: function () {
            return this._gradient;
        },
        set: function (value) {
            if (this._gradient == value)
                return;
            if (this._gradient)
                this.iRemoveTexture(this._gradient);
            this._gradient = value;
            if (this._gradient)
                this.iAddTexture(this._gradient);
            this.invalidateShaderProgram();
        },
        enumerable: false,
        configurable: true
    });
    DiffuseGradientMethod.assetType = '[asset DiffuseGradientMethod]';
    return DiffuseGradientMethod;
}(DiffuseBasicMethod));
export { DiffuseGradientMethod };
import { ShaderBase, ImageTexture2D } from '@awayjs/renderer';
/**
 * _Shader_DiffuseGradientMethod is an alternative to _Shader_DiffuseBasicMethod in which the shading can be modulated with a gradient
 * to introduce color-tinted shading as opposed to the single-channel diffuse strength. This can be used as a crude
 * approximation to subsurface scattering (for instance, the mid-range shading for skin can be tinted red to similate
 * scattered light within the skin attributing to the final colour)
 */
var _Shader_DiffuseGradientMethod = /** @class */ (function (_super) {
    __extends(_Shader_DiffuseGradientMethod, _super);
    /**
     * Creates a new _Shader_DiffuseGradientMethod object.
     * @param gradient A texture that contains the light colour based on the angle. This can be used to change
     * the light colour due to subsurface scattering when the surface faces away from the light.
     */
    function _Shader_DiffuseGradientMethod(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    _Shader_DiffuseGradientMethod.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        var texture = this._method.gradient || new ImageTexture2D();
        this._gradient = texture.getAbstraction(this._shader);
        this._gradient._initVO(chunkVO);
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseGradientMethod.prototype._initConstants = function () {
        this._gradient._initConstants();
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseGradientMethod.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
        this._pIsFirstLight = true;
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseGradientMethod.prototype._getFragmentCodePerLight = function (lightDirReg, lightColReg, registerCache, sharedRegisters) {
        var code = '';
        var t;
        // write in temporary if not first light, so we can add to total diffuse colour
        if (this._pIsFirstLight)
            t = this._totalLightColorReg;
        else {
            t = registerCache.getFreeFragmentVectorTemp();
            registerCache.addFragmentTempUsages(t, 1);
        }
        code += 'dp3 ' + t + '.w, ' + lightDirReg + '.xyz, ' + sharedRegisters.normalFragment + '.xyz\n' +
            'mul ' + t + '.w, ' + t + '.w, ' + sharedRegisters.commons + '.x\n' +
            'add ' + t + '.w, ' + t + '.w, ' + sharedRegisters.commons + '.x\n' +
            'mul ' + t + '.xyz, ' + t + '.w, ' + lightDirReg + '.w\n';
        if (this._modulateFunction != null)
            code += this._modulateFunction(t, registerCache, sharedRegisters);
        code += this._gradient._getFragmentCode(t, registerCache, sharedRegisters, t) +
            //					"mul " + t + ".xyz, " + t + ".xyz, " + t + ".w\n" +
            'mul ' + t + '.xyz, ' + t + '.xyz, ' + lightColReg + '.xyz\n';
        if (!this._pIsFirstLight) {
            code += 'add ' + this._totalLightColorReg + '.xyz, ' + this._totalLightColorReg + '.xyz, ' + t + '.xyz\n';
            registerCache.removeFragmentTempUsage(t);
        }
        this._pIsFirstLight = false;
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseGradientMethod.prototype._activate = function () {
        _super.prototype._activate.call(this);
        this._gradient.activate();
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseGradientMethod.prototype._setRenderState = function (renderState) {
        _super.prototype._setRenderState.call(this, renderState);
        this._gradient._setRenderState(renderState);
    };
    return _Shader_DiffuseGradientMethod;
}(_Shader_DiffuseBasicMethod));
export { _Shader_DiffuseGradientMethod };
ShaderBase.registerAbstraction(_Shader_DiffuseGradientMethod, DiffuseGradientMethod);
